/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { useEffect, useState, useMemo, useCallback } from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Gantt, Willow } from "wx-react-gantt";
// @ts-ignore
import "wx-react-gantt/dist/gantt.css";
// @ts-ignore
import "./gantt-custom.css";

import clientColors from "./ClientColors.json"; // ⬅️ color palette
import { getBulkCampaignGanttChart} from '../../../services/bulkEmailServices';
import { getCampaignESPConnections, getESPConnectionData } from '../../../services/emailAPIESPServices';
// Material UI
import {
  Box,
  Typography,
  FormControl,
  Autocomplete,
  TextField,
} from "@mui/material";
import GradientButton from '../../MUICustomButton/GradientButton';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import {ArrowDown01Icon } from "@hugeicons-pro/core-stroke-standard";
//@ts-ignore
import { HugeiconsIcon } from "@hugeicons/react";
import moment from "moment";
import { getAllClientData } from "src/services/clientService";
import { NotificationManager } from "react-notifications";
import { BottomRightBox } from "./BottomRightBox";
// Extend the Window interface to include tooltipDebugStart
declare global {
  interface Window {
    tooltipDebugStart?: number;
  }
}


interface ResendItem {
  clientId: number | string;
  clientName: string;
  campaignName: string;
  isResend: true;
  startDateTime: string;
  endDateTime: string;
  recordsCount: number;
  resends: ResendItem[];
}

interface CampaignItem {
  clientId: string;
  campaignName: string;
  startDateTime: string;
  endDateTime: string;
  recordCount?: number;
  resends?: ResendItem[];
  [key: string]: unknown;
}
interface CampaignRequestData {
  espConnectionId: string | number; // adjust type based on your API
  clientId?: string;
}

const ReactGanttChart = (): JSX.Element => {
  const [scaleValue, setScaleValue] = useState<number>(1);
  const [campaignData, setCampaignData] = useState<CampaignItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [clientList, setClientList] = useState<any[]>([]);
  const [selectedClient, setSelectedClient] = useState<string>("");
  const [espConnectionList, setEspConnectionList] = useState<any[]>([]);
  const [selectedEspConnection, setSelectedEspConnection] = useState<any>(null);
  const [espLoading, setEspLoading] = useState<boolean>(false);
  const [tooltip, setTooltip] = useState<{
    visible: boolean;
    x: number;
    y: number;
    data?: any;
  }>({ visible: false, x: 0, y: 0 });

  // Read the stored user once and reuse
  const storedUser = useMemo(() => JSON.parse(localStorage.getItem("user") ?? "{}"), []);

  const engageBeUrl = useMemo(() => {
    const storedAppConfig = localStorage.getItem("appConfigs");
    const parsedAppConfig = storedAppConfig ? (JSON.parse(storedAppConfig) as any[]) : [];
    return parsedAppConfig.find((item: any) => item.configType === 'EngageApp' && item.configName === 'BaseURLBE')?.configValue ?? '';
  }, []);

  // Fetch ESP connections when a client is selected
  const fetchEspConnections = useCallback(async (clientId: string | number): Promise<void> => {
    if (!clientId) {
      setEspConnectionList([]);
      setSelectedEspConnection(null);
      return;
    }
    try {
      setEspLoading(true);
      setEspConnectionList([]);
      setSelectedEspConnection(null);
      const [campaignRes, espRes] = await Promise.all([
        getCampaignESPConnections(engageBeUrl, Number(clientId)),
        getESPConnectionData(),
      ]);
      if ((campaignRes as any)?.status === 200 && (campaignRes as any)?.data?.success === true) {
        const espAllData: any[] = (espRes as any)?.data?.data ?? [];
        const mapped = ((campaignRes as any).data.data as any[]).map((item: any) => {
          const match = espAllData.find((e: any) => String(e.id) === String(item.espConnectionId));
          return {
            ...item,
            id: item.espConnectionId,
            connectionName: match?.connectionName ?? item.espDomainName,
          };
        });
        setEspConnectionList(mapped);
      }
    } catch (err: any) {
      NotificationManager.error("Failed to load ESP connections");
    } finally {
      setEspLoading(false);
    }
  }, [engageBeUrl]);

  // Memoized fetchCampaignData function
  const fetchCampaignData = useCallback(async (espConnectionId: string | number, clientId?: string | number): Promise<void> => {
    try {
      setLoading(true);

      const data: CampaignRequestData = { espConnectionId };

      if (clientId !== undefined && clientId !== null && clientId !== "") {
        const clientIdStr = String(clientId).trim();
        if (clientIdStr !== "" && clientIdStr !== "undefined" && clientIdStr !== "null") {
          data.clientId = clientIdStr;
        }
      }

      const response = await getBulkCampaignGanttChart(data);

      if (response?.data?.data && Array.isArray(response.data.data)) {
        setCampaignData(response.data.data);
      } else if (Array.isArray(response?.data)) {
        setCampaignData(response.data);
      } else if (Array.isArray(response)) {
        setCampaignData(response);
      } else {
        setCampaignData([]);
      }
    } catch (err: any) {
      NotificationManager.error(err?.message || "Failed to fetch campaign data");
      setCampaignData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Load clients on mount only (no chart data fetch)
  useEffect(() => {
    const loadClients = async (): Promise<void> => {
      try {
        const user = storedUser;
        const clientResponse = await getAllClientData(user?.roleID ?? undefined);

        let activeClients: any[] = [];
        if (clientResponse?.status === 200 && clientResponse?.data?.result === 1) {
          activeClients = clientResponse.data.data.filter((c: any) => c.isActive);
        }

        const userClientId = user?.clientId;
        if (userClientId !== undefined && userClientId !== null && String(userClientId).trim() !== "") {
          const exists = activeClients.some((c: any) => String(c.id) === String(userClientId));
          if (!exists) {
            activeClients = [{
              id: userClientId,
              clientName: user?.clientName ?? `Client ${userClientId}`,
              isActive: true,
            }, ...activeClients];
          }
        }

        setClientList(activeClients);
      } catch (err: any) {
        setClientList([]);
      }
    };

    void loadClients();
  }, [storedUser]);

  const handleSubmit = (): void => {
    if (!selectedEspConnection) {
      NotificationManager.error("Please select an ESP connection");
      return;
    }
    setCampaignData([]);
    void fetchCampaignData(selectedEspConnection.id, selectedClient || undefined);
  };


  // Helper function to create resend color variations
  const createResendColor = (baseColor: string, resendIndex = 0): string => {
    // Remove # if present
    const hex = baseColor.replace('#', '');
    
    // Convert to RGB
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    
    // For the first resend, create a lighter/more golden variation
    // Subsequent resends get progressively different
    let newR, newG, newB;
    
    if (resendIndex === 0) {
      // First resend: Make it lighter and more golden (like #ea940a -> #eca83c)
      newR = Math.min(255, Math.round(r + (255 - r) * 0.15)); // Slightly lighter red
      newG = Math.min(255, Math.round(g + (255 - g) * 0.25)); // More golden/yellow
      newB = Math.min(255, Math.round(b + (255 - b) * 0.35)); // Add some brightness
    } else {
      // Subsequent resends: Create variations by adjusting saturation and brightness
      const factor = 0.2 + (resendIndex * 0.1);
      newR = Math.round(r + (128 - r) * factor);
      newG = Math.round(g + (128 - g) * factor);
      newB = Math.round(b + (128 - b) * factor);
    }
    
    // Ensure values are within bounds
    newR = Math.max(0, Math.min(255, newR));
    newG = Math.max(0, Math.min(255, newG));
    newB = Math.max(0, Math.min(255, newB));
    
    // Convert back to hex
    return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
  };

  // Create a stable client-to-color mapping
 const clientColorMapping = useMemo(() => {
  if (!campaignData.length) return {};

  const seen = new Set<string>();
  const clients: string[] = [];

  // Preserve first appearance order
  campaignData.forEach((c) => {
    if (!seen.has(c.clientId)) {
      seen.add(c.clientId);
      clients.push(c.clientId);
    }
  });

  const mapping: Record<string, string> = {};
  clients.forEach((clientId, index) => {
    mapping[clientId] = clientColors.colors[index % clientColors.colors.length];
  });

  return mapping;
}, [campaignData]);

  // Get color for a specific client
  const getClientColor = (clientId: string): string => {
    return clientColorMapping[clientId] || clientColors.colors[0];
  };

  const tasks = useMemo(() => {
    if (!campaignData.length) return [];
    
    const result: any[] = [];
    const clients = [...new Set(campaignData.map((c) => c.clientId))];

    clients.forEach((clientId: string) => {
      const clientCampaigns = campaignData.filter((c) => c.clientId === clientId);
      if (!clientCampaigns.length) return;

      const clientColor = getClientColor(clientId);
      const clientName = clientCampaigns[0]?.clientName ?? `Client ${clientId}`;
      // Parent client row
      result.push({
        id: `client-${clientId}`,
        text: clientName,
        type: "project",
        open: true,
        render: "split",
        readonly: true,
        styles: {
          fontWeight: "600",
          fontSize: "16px",
          color: "#3A3A3A",
        },
      });
//@ts-ignore
      clientCampaigns.forEach((item: CampaignItem, i: number) => {
        const startDate = new Date(item.startDateTime);
        const endDate = new Date(item.endDateTime);
        const durationInHours = Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60));

        // Main campaign
        const campaignId = `task-${clientId}-${i + 1}`;
        result.push({
          id: campaignId,
          parent: `client-${clientId}`,
          text: `${item.campaignName} (${durationInHours}h)`,
          start: startDate,
          end: endDate,
          color: clientColor,
          readonly: true,
          unscheduled: false,
          styles: {
            backgroundColor: clientColor,
            borderColor: clientColor,
          },
          campaignDetails: {
            ...item,
            durationInHours: durationInHours,
            clientColor,
            clientId,
            isResend: false,
            recordCount: item.recordCount ?? item.recordsCount ?? 0, 
          },
        });

        // Add resends if they exist
        if (item.resends && item.resends.length > 0) {
          item.resends.forEach((resend: ResendItem, resendIndex: number) => {
            const resendStartDate = new Date(resend.startDateTime);
            const resendEndDate = new Date(resend.endDateTime);
            const resendDurationInHours = (resendEndDate.getTime() - resendStartDate.getTime()) / (1000 * 60 * 60);
            
            // Create resend color variation
            const resendColor = createResendColor(clientColor, resendIndex);
            
            result.push({
              id: `task-${campaignId}-resend-${resendIndex + 1} child-text`,
              parent: `client-${clientId}`,
              text: `  ↳ ${resend.campaignName} (${resendDurationInHours.toFixed(0)}h)`,
              start: resendStartDate,
              end: resendEndDate,
              color: resendColor,
              readonly: true,
              unscheduled: false,
              styles: {
                backgroundColor: resendColor,
                borderColor: resendColor,
                fontStyle: "italic",
                fontSize: "13px",
                paddingLeft: "20px",
              },
              campaignDetails: {
                ...resend,
                durationInHours: resendDurationInHours.toFixed(0),
                clientColor: resendColor,
                clientId: resend.clientId,
                isResend: true,
                parentCampaign: item.campaignName,
                recordCount: resend.recordsCount, // Map recordsCount to recordCount for consistency
              },
            });
          });
        }
      });
    });

    return result;
  }, [campaignData, scaleValue, clientColorMapping]);

  // Apply colors to Gantt bars after rendering - Enhanced for tooltip compatibility
  useEffect(() => {
    if (!campaignData.length || loading) return;
    
    const applyColorsToGanttBars = (): void => {
      // Hide parent client bars but keep their text visible
      const clientBars = document.querySelectorAll(
        '[data-task-id*="client-"] rect, [data-id*="client-"] rect'
      );
      clientBars.forEach((bar) => {
        (bar as HTMLElement).style.display = "none";
        (bar as HTMLElement).style.visibility = "hidden";
      });

      // Keep client text labels visible
      const clientTexts = document.querySelectorAll(
        '[data-task-id*="client-"] text, [data-id*="client-"] text'
      );
      clientTexts.forEach((text) => {
        (text as HTMLElement).style.display = "block";
        (text as HTMLElement).style.visibility = "visible";
      });

      // Apply colors to campaign bars (including resends)
      tasks.forEach((task) => {
        if (task.parent && task.color) {
          const selectors = [
            `[data-id="${task.id}"]`,
            `[data-task-id="${task.id}"]`,
            `.wx-bar[data-id="${task.id}"]`,
            `#${task.id}`,
            `g[data-task-id="${task.id}"] rect`,
            `g[data-id="${task.id}"] rect`,
          ];

          selectors.forEach(selector => {
            const elements = document.querySelectorAll(selector);
            elements.forEach((element) => {
              if (element.tagName.toLowerCase() === 'rect' || element.classList.contains('wx-bar')) {
                (element as HTMLElement).style.fill = task.color;
                (element as HTMLElement).style.backgroundColor = task.color;
                (element as HTMLElement).style.borderColor = task.color;
                (element as HTMLElement).setAttribute('data-client-color', task.color);
                
                // Ensure tooltip data attributes are present
                (element as HTMLElement).setAttribute('data-id', task.id);
                (element as HTMLElement).setAttribute('data-task-id', task.id);
                
                // Make sure the element is interactive
                (element as HTMLElement).style.pointerEvents = 'all';
                (element as HTMLElement).style.cursor = 'pointer';
                
                // Add special styling for resends
                if (typeof task.id === "string" && task.id.includes('-resend-')) {
                  (element as HTMLElement).style.opacity = '1';
                  (element as HTMLElement).style.strokeWidth = '1px';
                  (element as HTMLElement).style.stroke = task.color;
                }

                // Also apply to parent g elements for better tooltip detection
                const parentG = element.closest('g');
                if (parentG) {
                  parentG.setAttribute('data-id', task.id);
                  parentG.setAttribute('data-task-id', task.id);
                  (parentG as unknown as HTMLElement).style.pointerEvents = 'all';
                }
              }
            });
          });
        }
      });

    };

    // Apply colors multiple times to ensure they stick and tooltip works
    const timeouts = [0, 100, 300, 500, 800, 1200].map(delay => 
      setTimeout(() => {
        applyColorsToGanttBars();
      }, delay)
    );

    return () => {
      timeouts.forEach(timeout => clearTimeout(timeout));
    };
  }, [tasks, campaignData, loading, scaleValue]); // Added scaleValue to reapply on zoom
// Add this useEffect in your component, replace existing tooltip effect
useEffect(() => {
  if (!tasks.length || loading) return;

  const handleMouseMove = (e: MouseEvent) : void => {
    const target = e.target as HTMLElement;

    // Check if this is a task bar or its parent
    const taskId = 
      target.getAttribute('data-id') ?? 
      target.getAttribute('data-task-id') ?? 
      target.closest<HTMLElement>('[data-id], [data-task-id]')?.getAttribute('data-id') ??
      target.closest<HTMLElement>('[data-id], [data-task-id]')?.getAttribute('data-task-id');

    if (!taskId) {
      setTooltip((prev) => ({ ...prev, visible: false }));
      return;
    }

    const task = tasks.find(t => t.id === taskId);
    if (!task?.campaignDetails || taskId.startsWith('client-')) {
      setTooltip((prev) => ({ ...prev, visible: false }));
      return;
    }

      const tooltipWidth = 300;  // approximate tooltip width
      const tooltipHeight = 120; // approximate tooltip height
      const padding = 12;        // margin from screen edges
      
      let x = e.clientX + 12;
      let y = e.clientY + 12;
      
      // Prevent right overflow
      if (x + tooltipWidth + padding > window.innerWidth) {
        x = window.innerWidth - tooltipWidth - padding;
      }
      
      // Prevent bottom overflow
      if (y + tooltipHeight + padding > window.innerHeight) {
        y = window.innerHeight - tooltipHeight - padding;
      }
      
      // Prevent top/left overflow
      if (x < padding) x = padding;
      if (y < padding) y = padding;
      
      setTooltip({
        visible: true,
        x,
        y,
        data: task.campaignDetails,
      });
 
  };

  const handleMouseLeave = () : void=> {
    setTooltip((prev) => ({ ...prev, visible: false }));
  };

  // Attach to document so clicks or Gantt redraws don’t remove tooltip
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseleave', handleMouseLeave);

  return () => {
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseleave', handleMouseLeave);
  };
}, [tasks, loading]);

  // Tooltip logic - More aggressive approach with mutation observer
  useEffect(() => {
    if (loading || !campaignData.length || !tasks.length) return;


    let isAttached = false;
    let cleanup: (() => void) | null = null;

    const findGanttContainer = (): HTMLElement | null => {
      const selectors = [
        ".wx-gantt",
        ".gantt-container", 
        "[data-testid='gantt']",
        ".wx-gantt-area",
        ".gantt-chart",
        ".wx-gantt-data-area",
        ".wx-gantt-grid-area"
      ];
      
      for (const selector of selectors) {
        const element = document.querySelector(selector) as HTMLElement;
        if (element) {
          return element;
        }
      }
      
      // Fallback - look for any element with gantt-related classes
      const allElements = document.querySelectorAll("*");
      for (const el of allElements) {
        const className = el.className;
        if (typeof className === 'string' && className.includes('gantt')) {
          return el as HTMLElement;
        }
      }
      
      return null;
    };

    const attachTooltipListeners = (): (() => void) | null => {
      const container = findGanttContainer();
      if (!container) {
        return null;
      }

      const handleMove = (e: Event): void => {
        const mouseEvent = e as MouseEvent;
        const target = mouseEvent.target as HTMLElement;
        
        // Log what we're hovering over (only in first few seconds)
        const now = Date.now();
        if (!window.tooltipDebugStart) window.tooltipDebugStart = now;
        const shouldLog = (now - window.tooltipDebugStart) < 5000;
      
        let taskElement: HTMLElement | null = null;
        let taskId: string | null = null;

        // Method 1: Direct data attributes on target
        if (target.getAttribute) {
          taskId = target.getAttribute("data-id") ??
                   target.getAttribute("data-task-id");
          if (taskId) {
            taskElement = target;
            if (shouldLog) console.log("Found taskId via direct attribute:", taskId);
          }
        }

        // Method 2: Look for closest .wx-bar
        if (!taskId) {
          taskElement = target.closest(".wx-bar") as HTMLElement;
          if (taskElement) {
            taskId = taskElement.getAttribute("data-id") ?? 
                     taskElement.getAttribute("data-task-id");
            if (shouldLog && taskId) console.log("Found taskId via .wx-bar:", taskId);
          }
        }

        // Method 3: Look for rect elements and their parents
        if (!taskId && target.tagName.toLowerCase() === 'rect') {
          taskId = target.getAttribute("data-id") ??
                   target.getAttribute("data-task-id");
          if (!taskId && target.parentElement) {
            taskId = target.parentElement.getAttribute("data-id") ??
                     target.parentElement.getAttribute("data-task-id");
          }
          taskElement = target;
          if (shouldLog && taskId) console.log("Found taskId via rect:", taskId);
        }

        // Method 4: Look up DOM tree
        if (!taskId) {
          let current = target.parentElement;
          let depth = 0;
          while (current && current !== container && depth < 10) {
            taskId = current.getAttribute("data-id") ??
                     current.getAttribute("data-task-id");
            if (taskId) {
              taskElement = current;
              if (shouldLog) console.log("Found taskId via parent traversal:", taskId, "depth:", depth);
              break;
            }
            current = current.parentElement;
            depth++;
          }
        }

        // Method 5: Check siblings for task data
        if (!taskId && target.parentElement) {
          const siblings = target.parentElement.children;
          for (const sibling of siblings) {
            taskId = sibling.getAttribute("data-id") ?? 
                     sibling.getAttribute("data-task-id");
            if (taskId) {
              taskElement = sibling as HTMLElement;
              if (shouldLog)
              break;
            }
          }
        }

        if (taskId && taskElement) {
          // Find the corresponding task data
          const task = tasks.find((t) => t.id === taskId);
          if (shouldLog) 
          
          if (task?.campaignDetails) {
            // Only show tooltip for campaign tasks, not client group headers
            if (!taskId.startsWith('client-')) {
              setTooltip({
                visible: true,
                x: mouseEvent.clientX,
                y: mouseEvent.clientY,
                data: task.campaignDetails,
              });
              if (shouldLog) console.log("Showing tooltip for:", taskId);
            } else {
              setTooltip((prev) => ({ ...prev, visible: false }));
            }
          } else {
            setTooltip((prev) => ({ ...prev, visible: false }));
          }
        } else {
          setTooltip((prev) => ({ ...prev, visible: false }));
        }
      };

      const handleLeave = (): void => {
        setTooltip((prev) => ({ ...prev, visible: false }));
      };

      // Use capture phase and multiple event types for better detection
      const eventOptions = { capture: true, passive: true };
      
      container.addEventListener("mousemove", handleMove as EventListener, eventOptions);
      container.addEventListener("mouseover", handleMove as EventListener, eventOptions);
      container.addEventListener("mouseleave", handleLeave as EventListener, eventOptions);
      
      // Also attach to document for fallback
      document.addEventListener("mousemove", handleMove as EventListener, eventOptions);

      isAttached = true;

      return () => {
        container.removeEventListener("mousemove", handleMove as EventListener, eventOptions);
        container.removeEventListener("mouseover", handleMove as EventListener, eventOptions);
        container.removeEventListener("mouseleave", handleLeave as EventListener, eventOptions);
        document.removeEventListener("mousemove", handleMove as EventListener, eventOptions);
      };
    };

    // Set up mutation observer to watch for DOM changes
    const observer = new MutationObserver((mutations) => {
      if (isAttached) return;
      
      let shouldRetry = false;
      mutations.forEach(mutation => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if gantt elements were added
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const element = node as Element;
              if (element.querySelector('.wx-bar, .wx-gantt, [data-id], [data-task-id]') ||
                  element.className?.toString().includes('gantt') ||
                  element.className?.toString().includes('wx-')) {
                shouldRetry = true;
                break;
              }
            }
          }
        }
      });
      
      if (shouldRetry) {
        setTimeout(() => {
          if (!isAttached) {
            const cleanupFn = attachTooltipListeners();
            if (cleanupFn) cleanup = cleanupFn;
          }
        }, 100);
      }
    });

    // Start observing DOM changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false
    });

    // Try immediate attachment
    const immediateCleanup = attachTooltipListeners();
    if (immediateCleanup) {
      cleanup = immediateCleanup;
    }

    // Try multiple times with increasing delays
    const delays = [100, 300, 500, 800, 1200, 2000, 3000];
    const timeouts = delays.map(delay => 
      setTimeout(() => {
        if (!isAttached) {
          const cleanupFn = attachTooltipListeners();
          if (cleanupFn) cleanup = cleanupFn;
        }
      }, delay)
    );

    return () => {
      observer.disconnect();
      if (cleanup) cleanup();
      timeouts.forEach(timeout => clearTimeout(timeout));
      isAttached = false;
      delete window.tooltipDebugStart;
    };
  }, [tasks, loading, campaignData, scaleValue]);

   const scales = useMemo(() => {
    return [
      {
        unit: "day",
        step: 1,
        format: (date: Date) => moment(date).format("MM-DD-YYYY"),
      },
      {
        unit: "hour",
        step: scaleValue,
        format: (date: Date) => moment(date).format("HH"),
      },
    ];
  }, [scaleValue]);

  const columns = useMemo(
    () => [
      {
        id: "text",
        header: "Schedule (Start Time)",
        width: 350, // Increased width to accommodate resend indentation
        headerStyles: {
          fontWeight: "700",
          fontSize: "16px",
        },
      },
    ],
    []
  );

  // Zoom control functions
  const handleZoomIn = (): void => {
    setScaleValue(prev => Math.min(24, prev + 1));
  };

  const handleZoomOut = (): void => {
    setScaleValue(prev => Math.max(1, prev - 1));
  };

  // Add dynamic CSS for colors including resends
  useEffect(() => {
    if (!Object.keys(clientColorMapping).length) return;

    const styleElement = document.createElement("style");
    styleElement.id = "gantt-dynamic-colors";

    let css = "";
    Object.entries(clientColorMapping).forEach(([clientId, color]) => {
      const resendColor = createResendColor(color, 0);
      
      css += `
        /* Original campaigns */
        g[data-task-id*="${clientId}-"] rect,
        .wx-bar[data-id*="${clientId}-"] {
          fill: ${color} !important;
          background-color: ${color} !important;
          border-color: ${color} !important;
        }
        
        /* Resend campaigns with custom color variations */
        g[data-task-id*="${clientId}-"][data-task-id*="-resend-"] rect,
        .wx-bar[data-id*="${clientId}-"][data-id*="-resend-"] {
          fill: ${resendColor} !important;
          background-color: ${resendColor} !important;
          border-color: ${resendColor} !important;
        }
      `;
    });

    styleElement.textContent = css;
    document.head.appendChild(styleElement);

    return () => {
      const existingStyle = document.getElementById("gantt-dynamic-colors");
      if (existingStyle) {
        existingStyle.remove();
      }
    };
  }, [clientColorMapping]);



  const DEFAULT_CLIENT = useMemo(() => ({ id: "", clientName: "All Clients" }), []);
  const options = useMemo(() => {
    // If selectedClient is a fallback that was inserted into clientList, options will include it.
    return [DEFAULT_CLIENT, ...clientList];
  }, [DEFAULT_CLIENT, clientList]);

  const selectedOption = useMemo(() => {
    // compare as strings to handle numeric IDs too
    return options.find((c) => String(c.id) === String(selectedClient)) ?? DEFAULT_CLIENT;
  }, [options, selectedClient]);

  const autocompleteInputSx = {
    width: { xs: '100%', sm: '250px', md: '250px', lg: '250px' },
    minWidth: '200px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '40px',
      backgroundColor: '#fff',
      paddingRight: '8px',
      height: '56px',
      '& .MuiOutlinedInput-input': { padding: '16px 14px', height: 'auto', lineHeight: '1.4375em' },
    },
    '& .MuiInputLabel-root': { padding: '0 4px', fontSize: '13px', lineHeight: '1.2' },
  };

  return (
      <div className="mt-[20px] mb-[20px] live-outreach-container">

{/* Header: Client + ESP dropdowns + Submit */}
<Box sx={{ mb: 2.5, display: "flex", justifyContent: "flex-start", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
  {/* Client dropdown */}
  <FormControl>
    <Autocomplete
      options={options}
      getOptionLabel={(option: any) => option.clientName}
      popupIcon={<HugeiconsIcon icon={ArrowDown01Icon} size={18} color="#3A3A3A" strokeWidth={0.5} />}
      isOptionEqualToValue={(option, value) => String(option.id) === String(value?.id)}
      value={selectedOption}
      onChange={(_, option) => {
        const clientId = option?.id ?? "";
        setSelectedClient(String(clientId));
        setSelectedEspConnection(null);
        setEspConnectionList([]);
        setCampaignData([]);
        if (clientId !== "") {
          void fetchEspConnections(clientId);
        }
      }}
      disabled={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Client"
          autoComplete="off"
          fullWidth
          InputLabelProps={{ shrink: true }}
          sx={autocompleteInputSx}
        />
      )}
    />
  </FormControl>

  {/* ESP Connection dropdown — always visible, disabled until a real client is selected */}
  <FormControl>
    <Autocomplete
      options={espConnectionList}
      getOptionLabel={(option: any) => option.connectionName ?? option.espDomainName ?? String(option.id)}
      popupIcon={<HugeiconsIcon icon={ArrowDown01Icon} size={18} color="#3A3A3A" strokeWidth={0.5} />}
      isOptionEqualToValue={(option, value) => String(option.id) === String(value?.id)}
      value={selectedEspConnection}
      onChange={(_, option) => {
        setSelectedEspConnection(option);
        setCampaignData([]);
      }}
      loading={espLoading}
      disabled={selectedClient === "" || loading || espLoading}
      renderInput={(params) => (
        <TextField
          {...params}
          label="ESP Connection"
          autoComplete="off"
          fullWidth
          InputLabelProps={{ shrink: true }}
          sx={autocompleteInputSx}
        />
      )}
    />
  </FormControl>

  {/* Submit button — always visible, disabled until client + ESP are selected */}
  <GradientButton
    color="red"
    onClick={handleSubmit}
    disabled={selectedClient === "" || loading || espLoading || !selectedEspConnection}
    width="120px"
    height="40px"
  >
    {loading ? <span className="loading loading-spinner loading-xs text-white"></span> : 'Submit'}
  </GradientButton>
</Box>

      {/* Content Area */}
      <Box sx={{ flex: 1, position: 'relative', overflow: 'hidden' }}>
        {/* Loading State */}
        {loading && (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "10vh", borderRadius: "8px", backgroundColor: "#fff" }}>
            <Typography sx={{ color: '#3A3A3A', fontSize: '14px' }} component="div">
              <div style={{ padding: '24px' }}>
                <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div>
              </div>
            </Typography>
          </Box>
        )}

        {/* Gantt Chart Content */}
        {!loading && campaignData.length > 0 && (
          <>
            <BottomRightBox scaleValue={scaleValue} onZoomIn={handleZoomIn} onZoomOut={handleZoomOut} />
            <Box sx={{ height: "100%", width: "100%", background: "#fff", position: "relative", flex: 1, overflow: 'hidden', borderRadius: "6px" }}>
              <Willow>
                {tooltip.visible && tooltip.data && (
                  <div
                    style={{
                      position: "fixed",
                      top: tooltip.y,
                      left: tooltip.x,
                      background: "#3A3A3A",
                      color: "#fff",
                      padding: "10px 14px",
                      borderRadius: "6px",
                      fontSize: "13px",
                      pointerEvents: "none",
                      whiteSpace: "nowrap",
                      zIndex: 1000,
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    }}
                  >
                    <strong>{tooltip.data.campaignName}</strong>
                    {tooltip.data.isResend && (<><br />Parent: {tooltip.data.parentCampaign}</>)}
                    <br />Records: {tooltip.data.recordCount}
                    <br />Duration: {tooltip.data.durationInHours} hours
                    <br />Start: {moment(tooltip.data.startDateTime).format("MM-DD-YYYY HH:mm")}
                    <br />End: {moment(tooltip.data.endDateTime).format("MM-DD-YYYY HH:mm")}
                  </div>
                )}
                <Gantt
                  tasks={tasks}
                  links={[]}
                  scales={scales}
                  columns={columns}
                  rowHeight={36}
                  barHeight={22}
                  showGridLines={true}
                  rowLines={true}
                  cellWidth={60 / scaleValue}
                  readonly={true}
                  editable={false}
                  taskDrag={false}
                  taskResize={false}
                  linkDrag={false}
                  taskProgress={false}
                />
              </Willow>
            </Box>
          </>
        )}

        {/* No data / initial state */}
        {!loading && campaignData.length === 0 && (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "10vh", borderRadius: "8px", backgroundColor: "#fff" }}>
            <Typography sx={{ color: '#3A3A3A', fontSize: '14px' }}>
              No record found. Try adjusting search criteria
            </Typography>
          </Box>
        )}
      </Box>
    </div>
  );
};

export default ReactGanttChart;